module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "pl-fl-header"
  }, [_c('a', {
    attrs: {
      "id": "here"
    }
  }, [_vm._v("Love and danger in the Alaskan wilderness ")])]), _c('a', {
    attrs: {
      "id": "here"
    }
  }, [_c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('b', [_c('i', [_vm._v("Buried")])])]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("After witnessing a murder, legal investigator Leah Marks flees to Alaska. But the killer has tracked her down and as he chases her into a snow-packed canyon, an avalanche buries them both. Saved by search-and-rescue specialist Cade Warren, Leah longs to tell him the truth. But how can she, without bringing even more danger into Cade’s life?")]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('b', [_c('i', [_vm._v("Untraceable")])])]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_vm._v("On a daring mission, search-and-rescue specialist Heidi Warren and her team step onto an icy Alaskan mountaintop…and right into a trap. A stranded gang of thieves holds them at gunpoint, forcing them to serve as guides along the treacherous path. Heidi needs someone to trust, but her rescue partner, Isaiah Callahan, is keeping secrets from her. Yet when a blizzard starts closing in, their options start running out...")])])]), _c('a', {
    attrs: {
      "id": "here"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbbd2b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Back_Cover_Text.vue
// module id = 57
// module chunks = 0